module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "bg-grey-white": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-select', {
    staticClass: "normal-input ml-4 select-dashboard",
    attrs: {
      "items": _vm.globalstats_categories,
      "autocomplete": ""
    },
    model: {
      value: (_vm.globalstats_category),
      callback: function($$v) {
        _vm.globalstats_category = $$v
      },
      expression: "globalstats_category"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": "",
      "sm6": "",
      "md3": ""
    }
  }, [_c('DashboardItem', {
    staticClass: "bg-white ma-2 pa-4 dashboard__item",
    attrs: {
      "title": "Users",
      "number": _vm.statsList.total_users
    }
  }, [_c('div', {
    staticClass: "my-4"
  }, [_c('DonutChart')], 1)])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": "",
      "sm6": "",
      "md3": ""
    }
  }, [_c('DashboardItem', {
    staticClass: "bg-white ma-2 pa-4 dashboard__item",
    attrs: {
      "title": "Subscribers",
      "number": '0'
    }
  }, [_c('div', {
    staticClass: "my-4"
  }, [_c('DonutChart')], 1)])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": "",
      "sm6": "",
      "md2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": ""
    }
  }, [_c('DashboardItem', {
    staticClass: "bg-white ma-2 pa-4 dashboard__item",
    attrs: {
      "title": "Artist signups",
      "number": _vm.statsList.signup_artist_users
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": ""
    }
  }, [_c('DashboardItem', {
    staticClass: "bg-white ma-2 pa-4 dashboard__item",
    attrs: {
      "title": "Total Uploads",
      "number": _vm.statsList.total_tracks
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": "",
      "sm6": "",
      "md2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": ""
    }
  }, [_c('DashboardItem', {
    staticClass: "bg-white ma-2 pa-4 dashboard__item",
    attrs: {
      "title": "Listener signups",
      "number": _vm.statsList.signup_listener_users
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": ""
    }
  }, [_c('DashboardItem', {
    staticClass: "bg-white ma-2 pa-4 dashboard__item",
    attrs: {
      "title": "Total Plays",
      "number": '' + _vm.statsList.played_albums
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": "",
      "sm6": "",
      "md2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": ""
    }
  }, [_c('DashboardItem', {
    staticClass: "bg-white ma-2 pa-4 dashboard__item",
    attrs: {
      "title": "Playlists created",
      "number": '' + _vm.statsList.created_playlists
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "bg-grey-white": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": "",
      "sm12": "",
      "md6": ""
    }
  }, [_c('DashboardItem', {
    staticClass: "bg-white ma-2 pa-4 dashboard__item chart-line",
    attrs: {
      "title": "Total Subscription Revenue",
      "number": _vm.statsList.donations_revenue
    }
  }, [_c('div', {
    staticClass: "my-4"
  }, [_c('LineChart')], 1)])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": "",
      "sm12": "",
      "md6": ""
    }
  }, [_c('DashboardItem', {
    staticClass: "bg-white ma-2 pa-4 dashboard__item chart-line",
    attrs: {
      "title": "Total Product sales",
      "number": _vm.statsList.sold_products
    }
  }, [_c('div', {
    staticClass: "my-4"
  }, [_c('LineChart')], 1)])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "bg-grey-white": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": "",
      "sm12": "",
      "md6": ""
    }
  }, [_c('DashboardItem', {
    staticClass: "bg-white ma-2 pa-4 dashboard__item chart-line",
    attrs: {
      "title": "Top streamed artists"
    }
  }, [_c('div', {
    staticClass: "my-4"
  }, _vm._l((_vm.statsList.top_5_played_genres), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "display-flex align-center justify-space-between font-inter text-14 my-3"
    }, [_c('span', {
      staticClass: "font-weight-500 text-grey-black-2"
    }, [_vm._v("\n              " + _vm._s(item.name) + "\n            ")]), _vm._v(" "), _c('span', {
      staticClass: "font-weight-600"
    }, [_vm._v(_vm._s(item.users_size) + " plays")])])
  }))])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": "",
      "sm12": "",
      "md6": ""
    }
  }, [_c('DashboardItem', {
    staticClass: "bg-white ma-2 pa-4 dashboard__item chart-line",
    attrs: {
      "title": "Most streamed spotlight videos"
    }
  }, [_c('div', {
    staticClass: "my-4"
  }, _vm._l((_vm.statsList.top_5_downloaded_genres), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "display-flex align-center justify-space-between font-inter text-14 my-3"
    }, [_c('span', {
      staticClass: "font-weight-500 text-grey-black-2"
    }, [_vm._v("\n              " + _vm._s(item.name) + "\n            ")]), _vm._v(" "), _c('span', {
      staticClass: "font-weight-600"
    }, [_vm._v(_vm._s(item.users_size) + " plays")])])
  }))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77332981","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/components/global_stats.vue
// module id = 1785
// module chunks = 180